__turbopack_context__.v({
  "desktopGrid": "Ek_47W_desktopGrid",
  "heading": "Ek_47W_heading",
  "mobileGrid": "Ek_47W_mobileGrid",
  "moreBtn": "Ek_47W_moreBtn",
  "moreWrap": "Ek_47W_moreWrap",
  "section": "Ek_47W_section",
  "status": "Ek_47W_status",
  "wrap": "Ek_47W_wrap",
});
